import {
  Injectable,
  OnDestroy,
  Renderer2,
  RendererFactory2,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseHrefService } from '@nibtravel/shared/util/base-href';
import { DomService } from '@nibtravel/shared/util/dom';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StyleLoaderService implements OnDestroy {
  document: Document;
  renderer: Renderer2;
  destroy$ = new Subject<void>();

  constructor(
    private hrefService: BaseHrefService,
    rendererFactory: RendererFactory2,
    private domService: DomService,
    private titleService: Title
  ) {
    this.document = this.domService.getDocument();
    this.renderer = rendererFactory.createRenderer(this.document, null);
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  /**
   * @description Load the brand's style and icon
   * @param brand string
   * @param prefix optional string (to ensure assets path for CMS is correct)
   */
  loadStyle(brand: string): void {
    const style = `${this.hrefService.baseHref}${brand}.css`;
    const icon = `${this.hrefService.baseHref}${brand}.ico`;

    // ensure the stylesheet/favico don't get added twice (this happens without this code in the CMS)
    if (!this.document.getElementById('brand-stylesheet')) {
      this.addLinkRel(style, 'stylesheet', 'brand-stylesheet');
    }

    if (!this.document.getElementById('brand-favicon')) {
      this.addLinkRel(icon, 'icon', 'brand-favicon');
    }
  }

  /**
   * This function loads brand and theme from the App Config and
   * initializes it by appeding the theme into the body classlist
   * and lay load the brand specific stylesheet.
   */
  initTheming(brand: string, title: string, theme: string, isStandAlone?: boolean): void {
    this.loadStyle(brand);

    this.renderer.addClass(this.document.body, theme);
    if (!isStandAlone) {
      this.titleService.setTitle(title);
    }
  }

  /* Create the dom element for the stylesheet and icon */
  private addLinkRel(href: string, rel: string, id: string): void {
    const link: HTMLLinkElement = this.renderer.createElement('link');
    link.id = id;
    link.href = href;
    link.rel = rel;

    if (rel === 'icon') {
      link.type = 'image/x-icon';
    } else if (rel === 'stylesheet') {
      link.type = 'text/css';
    }

    this.renderer.appendChild(this.document.head, link);
  }
}
